import React from 'react';
import Index from './Index';
import ChartOfAccountsView from '../components/views/ChartOfAccountsView';
import { modules } from '../config/const';

function ChartOfAccountsPage() {
  return <Index content={ChartOfAccountsView} module={modules.ChartOfAccounts} />;
}

export default ChartOfAccountsPage;
